import React, { Component } from "react";
import { inject, observer } from "mobx-react";

import MusicianProfile from "./MusicianProfile";
import AgentProfile from "./AgentProfile";
import VenueProfile from "./VenueProfile";
import ActProfile from "./ActProfile";
import PageNotFound from "./PageNotFound";
import Splash from "../Splash";

// Demo profile data for development preview
const DEMO_PROFILE = {
    id: "demo-musician",
    type: 1, // Musician type
    fullName: "Demo Artist",
    firstName: "Demo",
    lastName: "Artist",
    city: "Sydney",
    state: "NSW",
    bio: "This is a demo musician profile showcasing the new media sections including multiple videos and photo gallery. This profile is for development preview purposes.",
    showAvatar: true,
    profileGenres: [
        { genre: { name: "Rock" } },
        { genre: { name: "Jazz" } },
        { genre: { name: "Blues" } }
    ],
    videoUrls: [
        { id: "1", url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ", provider: "youtube", title: "Demo Video 1", thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg" },
        { id: "2", url: "https://www.youtube.com/watch?v=9bZkp7q19f0", provider: "youtube", title: "Demo Video 2", thumbnail: "https://img.youtube.com/vi/9bZkp7q19f0/hqdefault.jpg" }
    ],
    galleryImages: [
        { id: "1", url: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800", name: "Live Performance" },
        { id: "2", url: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800", name: "Studio Session" },
        { id: "3", url: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800", name: "Concert Night" },
        { id: "4", url: "https://images.unsplash.com/photo-1501612780327-45045538702b?w=800", name: "Festival Stage" }
    ],
    musicUrl: "https://open.spotify.com/artist/4Z8W4fKeB5YxbusRsdQVPb",
    playedAts: [
        { name: "Sydney Opera House", suburb: "Sydney", state: "NSW", country: "Australia" },
        { name: "Melbourne Arena", suburb: "Melbourne", state: "VIC", country: "Australia" }
    ],
    playedWiths: [
        { name: "Famous Band", notes: "Opening act 2023" }
    ],
    showPlayedWith: true,
    testimonials: [
        { name: "John Smith", content: "Amazing performance! Highly recommended.", position: "Event Manager" }
    ],
    webSite: "https://example.com",
    facebook: "https://facebook.com/demo",
    instagram: "https://instagram.com/demo",
    spotify: "https://open.spotify.com/artist/demo",
    ownedActs: [
        { id: "act1", actName: "The Demo Band", profileImage: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=400", genres: ["Rock", "Blues"] },
        { id: "act2", actName: "Jazz Ensemble", profileImage: "https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?w=400", genres: ["Jazz", "Swing"] }
    ],
    memberActs: [
        { id: "act3", actName: "City Orchestra", profileImage: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=400", genres: ["Classical", "Contemporary"] },
        { id: "act4", actName: "Festival Collective", profileImage: "https://images.unsplash.com/photo-1501612780327-45045538702b?w=400", genres: ["World", "Fusion"] }
    ]
};

@inject("profileStore","hgBillingStore")
@observer
class PublicProfile extends Component {
    state = {
        profile: null,
        finishLoading: false,
        isFreePlan: false
    };

    // load profile initially
    componentDidMount = () => {
        this.loadProfile();
    };

    // check if we get an update, usually by choosing the musician profile in the user popup
    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.loadProfile();
        }
    }

    loadProfile = async  () => {
        const param = this.props.match.params.id;
        let searchById = this.props.location.pathname.startsWith("/profile/");

        // Check for demo mode - use demo profile for development preview
        if (param === "demo" || param === "demo-musician") {
            this.setState({
                profile: DEMO_PROFILE,
                finishLoading: true,
                isFreePlan: false
            });
            return;
        }

        if (searchById) {
            await Promise.all([
                this.props.hgBillingStore.getProfileAccess(param),
                this.props.profileStore.getPublicProfileById(param)
            ])
            .then(result => {
                this.setState({
                    profile: result[1],
                    finishLoading: true,
                    isFreePlan: result[0]? result[0].isFreePlan : true
                });
                this.props.profileStore.logProfileViews(param)
            });
        } else {
            if (param !== "null") {
                this.props.profileStore.getPublicProfileByVanityUrl(param).then(result => {
                    this.props.hgBillingStore.getProfileAccess(result.id).then(res => {
                        this.setState({
                            profile: result,
                            finishLoading: true,
                            isFreePlan: res.isFreePlan
                        });
                        this.props.profileStore.logProfileViews(result.id)
                    })
                  
                });
            }
        }
    };

    getContent = profile => {
        switch (profile.type) {
            case 1:
                return <MusicianProfile profile={profile} isFreePlan={this.state.isFreePlan}/>;
            case 8: 
            case 2:
                return <AgentProfile profile={profile} isFreePlan={this.state.isFreePlan}/>;
            case 3:
                return <VenueProfile profile={profile} isFreePlan={this.state.isFreePlan}/>;
            case 4:
                return <ActProfile profile={profile} isFreePlan={this.state.isFreePlan}/>;
            case 5:
                return <VenueProfile profile={profile} isFreePlan={this.state.isFreePlan}/>;
            default:
                return <PageNotFound />;
        }
    };

    render() {
        if (this.props.match.params.id === "null") {
            return <PageNotFound />
        }
        return (
            <React.Fragment>
                {this.state.profile ? this.getContent(this.state.profile) : this.state.finishLoading ? <PageNotFound /> : <Splash/>}
            </React.Fragment>
        );
    }
}
export default PublicProfile;
